import { Component, NgZone, OnInit } from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators, AbstractControl} from '@angular/forms';
import {ApiService} from '../services/api.service';
import {AppComponent} from '../app.component';
import * as moment from 'moment';
import {  Router } from '@angular/router';
import { environment } from 'src/environments/environment';
declare var Razorpay: any;

@Component({
  selector: 'app-add-dharmshala-booking',
  templateUrl: './add-dharmshala-booking.component.html',
  styleUrls: ['./add-dharmshala-booking.component.scss']
})
export class AddDharmshalaBookingComponent implements OnInit {
public env: any = environment;


  form: FormGroup;
  allDharmshala: any[] = [];
  minDate = moment(new Date()).format('YYYY-MM-DD');
  maxDate = '';
  extraBedCount = 0;
  initialVisitorCount = 0;
  totalAmount = 100;
  apiLoadInterval = null;
  availableRooms: any[] = [];
  allIdProofTypes: any[] = [];
  bookingData: any;
  showPay = false;

  Payform: FormGroup;
  allPaymentTypes = [];
  countriesData = [];
  allStates = [];
  payment_type_id = '';
  donation_id;
  visitorDetails: any = {};
  transaction_no = '';
  transaction_validation_msg = '';
  addPayment = false;
  allPaymentGateways = [];

  constructor(
    private _formBuilder: FormBuilder,
    private apiService : ApiService,
    private appComponent: AppComponent,
    private router: Router,
    private _ngZone: NgZone
    ) {
    }

  ngOnInit() {
    this.createForm();
    this.AllDharmshalaList();
    this.getIdProofTypes();
    this.getAllPaymentTypes();
    this.getAllCountries();
    this.form.get('request_for_date').valueChanges.subscribe(() => {
      this.getAvailableRooms();
    });

    this.form.get('checkout_date').valueChanges.subscribe(() => {
      this.getAvailableRooms();
    });

    this.form.get('dharmshala_id').valueChanges.subscribe(() => {
      this.getAvailableRooms();
    });

    this.form.get('room_type_id').valueChanges.subscribe(() => {
      this.onRoomTypeChange();
    });

     this.form.get('country_id').valueChanges.subscribe((countryId) => {
      this.updateCountryBasedValidation(countryId);
    });
  }

  createForm() {
    this.form = this._formBuilder.group({
      dharmshala_id: ['', Validators.required],
      mobile_no: ['',[Validators.required,Validators.pattern('^[0-9]{10}$')]],
      request_for_date: ['', Validators.required],
      checkout_date: ['', Validators.required],
      room_type_id: ['', Validators.required],
          email_id: ['',[Validators.required,Validators.email]],
          country_id: ['',[Validators.required]],
          state_id: ['',[Validators.required]],
          city: ['',[Validators.required, Validators.pattern(/^[A-Za-z0-9\s-]+$/)]],
          pin_code: ['', [Validators.required,Validators.pattern(/^[0-9]{6}$/)]],
      visitors_basic_details: this._formBuilder.array([])
    });

   
  }

  isIndiaSelected(): boolean {
    return this.form.get('country_id').value == 1;
  }
  updateCountryBasedValidation(countryId: number) {

    const pinCodeControl = this.form.get('pin_code');
    const stateControl = this.form.get('state_id');

    const INDIA_COUNTRY_ID = 1;

    if (countryId == INDIA_COUNTRY_ID) {

      pinCodeControl.setValidators([
        Validators.required,
        Validators.pattern(/^[0-9]{6}$/)
      ]);

      stateControl.setValidators([
        Validators.required
      ]);

    } else {

      pinCodeControl.clearValidators();

      // agar optional rakhna hai to sirf pattern
      pinCodeControl.setValidators([
        Validators.pattern(/^[0-9]*$/)
      ]);

      stateControl.clearValidators();

      stateControl.setValue(null);
    }

    pinCodeControl.updateValueAndValidity();

    stateControl.updateValueAndValidity();
  }

  getAllCountries() {
    this.apiService.getDataFromPublicServer('/public/api/v1/countries').subscribe(
      (res:any) => {
        this.countriesData = res.data;
      },
      err => {
        console.log(err);
      }
    );
  }

  onCountryChange(id:any) {
    this.apiService.getDataFromPublicServer(`/public/api/v1/states?country_id=${id}`).subscribe(
      (res:any) => {
         this.allStates = res.data;
      },
      err => {
        console.log(err);
      }
    );
  }

  get visitorsControls() {
      return this.form.get('visitors_basic_details') as FormArray;
    }
  createVisitorGroup(_data?: any): FormGroup {
    const group = this._formBuilder.group({
      full_name: [(_data && _data.full_name) || '', Validators.required],
      age: [(_data && _data.age) || '', [Validators.required, Validators.min(1), Validators.max(120)]],
      gender: [(_data && _data.gender) || '', Validators.required],
      id_proof_type_id: ['', Validators.required],
      id_proof_number: ['', Validators.required],
      purpose_of_visit: ['Darshan', Validators.required]
    });

      group.get('id_proof_type_id').valueChanges.subscribe(type => {
      this.setIdProofValidation(group, type);
    });

    return group;
  }

  setIdProofValidation(group: FormGroup, proofType: any) {

      const control = group.get('id_proof_number');

      control.clearValidators();

      if (proofType == 1) {
        // Aadhaar
        control.setValidators([
          Validators.required,
          Validators.pattern(/^[0-9]{12}$/)
        ]);
      }
      else if (proofType == 2) {
        // Passport
        control.setValidators([
          Validators.required,
          Validators.pattern(/^[A-Z][0-9]{7}$/)
        ]);
      }
      else {
        control.setValidators([
          Validators.required
        ]);
      }

      control.updateValueAndValidity();
    }

  addVisitor() {
    this.visitorsControls.push(this.createVisitorGroup());
    this.extraBedCount++;
  }

  removeVisitor(index: number) {
    // Only decrement extraBedCount if removing an extra bed (added after initial capacity)
    if (index >= this.initialVisitorCount) {
      this.extraBedCount--;
    }
    this.visitorsControls.removeAt(index);
  }
  onRoomTypeChange() {

  const roomTypeId = this.form.get('room_type_id').value;

  const selectedRoom = this.availableRooms.find(
    room => room.room_type_id == roomTypeId
  );


  if (!selectedRoom) {
    return;
  }

  const capacity = Number(selectedRoom.max_guest_capacity);

  const visitorsArray = this.visitorsControls;

  // Purani rows remove
  while (visitorsArray.length > 0) {
    visitorsArray.removeAt(0);
  }

  // Reset extra bed count when room type changes
  this.extraBedCount = 0;

  // Capacity ke according rows create
  for (let i = 0; i < capacity; i++) {
    visitorsArray.push(this.createVisitorGroup());
  }

  // Track initial visitor count
  this.initialVisitorCount = capacity;
}

  getAvailableRooms() {

    const checkInDate = this.form.get('request_for_date').value;
    const checkOutDate = this.form.get('checkout_date').value;
    const dharmshalaId = this.form.get('dharmshala_id').value;

    // Jab tak teeno values na mil jaye API call mat karo
    if (!checkInDate || !checkOutDate || !dharmshalaId) {
      return;
    }

    const fromDate = moment(checkInDate).format('YYYY-MM-DD');
    const toDate = moment(checkOutDate).format('YYYY-MM-DD');

    this.apiService
      .getDataFromServer(
        `/available_rooms?from_date=${fromDate}&to_date=${toDate}&dharmshala_id=${dharmshalaId}&booking_source=admin`
      )
      .subscribe(
        (res: any) => {
          this.availableRooms = res.data || [];
        },
        err => {
          console.log(err);
        }
      );
  }

  AllDharmshalaList() {
    this.apiService
      .getDataFromServer(`/dharmashalas`).subscribe(
        (res: any) => {
          this.allDharmshala = res.data || [];
        },
        err => {
          console.log(err);
        }
      );
  }

  getIdProofTypes() {
    this.apiService.getDataFromServer('/id_proof_types').subscribe(
      res => {
        this.allIdProofTypes = res['data'];
      },
      err => {
        console.log(err);
      }
    );
  }
  

  saveData() {
    const formData = {
      ...this.form.value,
      request_for_date: moment(this.form.value.request_for_date).format('YYYY-MM-DD'),
      checkout_date: moment(this.form.value.checkout_date).format('YYYY-MM-DD'),
    };
    
    formData.amount = this.totalAmount;
    formData.no_of_extra_bed = this.extraBedCount;
    this.appComponent.showLoader();

    this.apiService
      .postDataToServer('/dharmshala_booking',formData)
      .subscribe(
        (res: any) => {

          this.appComponent.hideLoader();
          // this.router.navigate(['/dharmshala-bookings']);
          this.showPay = true;
          this.bookingData = res.data;
          console.log('bookingData', this.bookingData);
          this.appComponent.showMessageAlert(
            res.message,
            'success'
          );
        },
        err => {
          this.appComponent.hideLoader();

          this.appComponent.showMessageAlert(
            err.error.error[0].message,
            'error'
          );
        }
      );
  }


/* */
getAllPaymentTypes() {
    this.apiService.getDataFromServer('/payment_types').subscribe(
      res => {
        this.allPaymentTypes = res['data'];
      },
      err => {
        console.log(err);
      }
    );
  }


  removeSpaces(control: AbstractControl) {
    if (control && control.value && !control.value.replace(/\s/g, '').length) {
      control.setValue('');
    }
    return null;
  }
  
  removeSpacesTransaction_no() {
    setTimeout(() => {
      const isWhitespace = (this.transaction_no).trim().length === 0;
      if (isWhitespace) {
        this.transaction_validation_msg = 'Please Enter Valid Transaction No. / Receipt No.'
      } else {
        this.transaction_validation_msg = ''
      }
    },200);
  
  }

  addPaymentDetail() {
    this.createPayForm();
    this.saveDataOfPayment();
  }
  
  
  
  createPayForm() {
    this.Payform = this._formBuilder.group({
        payer_full_name: this.bookingData.full_name,
        service_id: this.bookingData.id,
        payer_contact: this.bookingData.mobile_no || '',
        payment_type_id:[this.payment_type_id,[Validators.required]],
        service_type: 'Dharmshala Booking',
        payment_gateway_id: 2
    });
  
  }
  
  
  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }
  
  close() {
    this.addPayment = false;
    this.createPayForm();
  }
  
  saveDataOfPayment() {
    this.appComponent.showLoader();
    this.apiService.postDataToServer('/make_payment', this.Payform.value).subscribe(
      (res:any) => {
        if(res.success) {
          // window.open(res.url);
          if(this.Payform.value.payment_gateway_id == 2){
            let _data = res.data;
            let options = {
              "key": this.env.razorpay_key,
              "amount": (_data.amount * 100),
              "currency": _data.currency,
              "name": "Mahakaleshwar Temple Prabhand Samiti Ujjain",
              "order_id": _data.id,
              "handler": (response: any) => {
                this.verifyPayment(response);
              },
              "prefill": {
                "name": _data.prefill_fields.name,
                "email": _data.prefill_fields.email,
                "contact": _data.prefill_fields.contact
              }
            };
            var rzp1 = new Razorpay(options);
  
            rzp1.open();
          } else {
            window.location.replace(res.url);
          }
        }
  
        this.appComponent.hideLoader();
      },
      err => {
        this.appComponent.hideLoader();
        this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
        console.log(err);
      }
    );
  }
  
  viewPass() {
    this.appComponent.showLoader();
    this.apiService.getDataFromServer('/generate_entry_pass/' + this.donation_id).subscribe(
      res => {
        window.open(res['data'][0]);
        this.appComponent.hideLoader();
      },
      err => {
        console.log(err);
      }
    );
  }
  
  savePayData() {
     let formObj = {
       booking_id :  this.bookingData.id,
       payment_type_id : this.payment_type_id,
       trx_id:  this.transaction_no
     };
  
    this.appComponent.showLoader();
    this.apiService.postPublicDataToServer('/checkin_payment', formObj).subscribe(
        (res:any) => {
          this.appComponent.showMessageAlert(res['message'], 'success');
          this.appComponent.hideLoader();
          this.router.navigate(['/dharmshala-booking']);
          this.close();
        },
        err => {
          this.appComponent.hideLoader();
          this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
          console.log(err);
        }
      );
  }
  
    verifyPayment(_data : any) {
      this.appComponent.showLoader();
      let formObj = {
        razorpay_payment_id: _data.razorpay_payment_id,
        razorpay_order_id: _data.razorpay_order_id,
        razorpay_signature: _data.razorpay_signature
      };
  
      this.apiService.postPublicDataToServer('/verify_payment', formObj).subscribe(
        (res : any) => {
          this.appComponent.hideLoader();
          this.appComponent.showMessageAlert(res['message'], 'success');
          this._ngZone.run(()=>{
            this.router.navigate(['/payment-status'], {queryParams: {redirect: true , clientTxnId: res['data']['clientTxnId'] }});
          });
  
        },
        err => {
          this.appComponent.hideLoader();
          this.appComponent.showMessageAlert(err.error.error[0].message, 'error');
          console.log(err);
        }
      );
    }
  

}
